import { lazy } from 'react';
import { lazyRetry } from '../utils/utils';

export { default as PaymentPage } from './PaymentPage/PaymentPage';

// lazy loaded pages
export const PaymentHelpPage = lazy(() => lazyRetry(() => import('./PaymentHelpPage/PaymentHelpPage'), './PaymentHelpPage/PaymentHelpPage'));
export const ReceiptAuth = lazy(() => lazyRetry(() => import('./ReceiptAuth/ReceiptAuth'), './ReceiptAuth/ReceiptAuth'));
export const ReceiptDashboard = lazy(() => lazyRetry(() => import('./ReceiptDashboard/ReceiptDashboard'), './ReceiptDashboard/ReceiptDashboard'));
export const PaymentStatus = lazy(() => lazyRetry(() => import('./PaymentStatus/PaymentStatus'), './PaymentStatus/PaymentStatus'));
export const PaymentRedirect = lazy(() => lazyRetry(() => import('./PaymentRedirectPage/PaymentRedirectPage'), './PaymentRedirectPage/PaymentRedirectPage'));
